import { parseRtf } from './parseRtf';

export const specialCharactersRegex = /[.*+?^${}()|[\]\\]/g;
export const escapeLinkSpecialCharacters = (link: string) => {
  return link?.replace(specialCharactersRegex, '\\$&').replace(/\//g, '\\$&');
};

const imageRegex = /\S{900,}/g;
export const removeImageString = (line: string) => {
  return line.replace(imageRegex, '');
};

export const linkRegex = /((http|https):\/\/)?([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])/g;
export const parseLineIntoTextPartsObject = (
  line: string
): { before: string; link: string; after?: string }[] => {
  const links = line.match(linkRegex);
  const result: { before: string; link: string; after?: string }[] = [];

  let lineWithPartsRemoved = line;

  links?.forEach((link, idx) => {
    const escapedLink = escapeLinkSpecialCharacters(link);
    const nextLinkBoundary = escapeLinkSpecialCharacters(links[idx + 1]) || '';

    const beforeAndAfterRegex = new RegExp(
      `(?:^)(.*?)${escapedLink}(.*?)(?:${nextLinkBoundary || '$'})`,
      'gi'
    );

    const match = beforeAndAfterRegex.exec(lineWithPartsRemoved.trimEnd());
    const before = match?.[1] || '';
    const after = match?.[2] || '';

    let lineParts;
    if ((idx === 0 && links.length === 1) || idx + 1 === links.length) {
      lineParts = {
        before,
        link,
        after: `${after} \n`
      };
    } else {
      lineParts = {
        before,
        link
      };
    }
    result.push(lineParts);

    // Remove processed parts from line
    lineWithPartsRemoved = lineWithPartsRemoved.replace(`${before}${link}`, '');
  });

  return result;
};

// Regular expression to match if the URL starts with http:// or https://
const protocolRegex = /^(http:\/\/|https:\/\/)/i;
export const ensureProtocol = (url: string) => {
  // If the URL starts with http:// or https://, return the URL as it is
  if (protocolRegex.test(url)) {
    return url;
  }
  // If the URL doesn't have a protocol, add http:// to it
  return `http://${url}`;
};

const lineRegex = /(.+?)(?:\r?\n|$)/g;
export const splitLinesRegex = (text: string) => {
  const lines = text.match(lineRegex);
  return lines;
};

export const splitTextIntoLinesArray = (
  text: string,
  simpleText: string,
  isRtf: boolean
): string[] | null => {
  let plainText: string | null = null;
  try {
    if (!text.trim()) return null;
    const cleanedString = removeImageString(text);
    plainText = cleanedString;
    if (isRtf) plainText = parseRtf(cleanedString);
    const lines = splitLinesRegex(plainText);
    return lines;
  } catch (error) {
    return simpleText ? [simpleText] : null;
  }
};
